import * as React from "react"
const IconFechaInicio = ({ width, height }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        data-name="Layer 1"
        viewBox="0 0 60 60"
        width={width}
        height={height}
    >
        <path
            d="M0 0h60v60H0z"
            style={{
                fill: "#eae0d8",
            }}
        />
        <path
            d="M1.84 1.81h56.32v56.32H1.84z"
            style={{
                fill: "none",
                stroke: "#354060",
                strokeMiterlimit: 10,
            }}
        />
        <path
            d="M47.3 13.01c.9.86.66 1.87.48 2.95-1.21 7.48-4.7 14.53-10.34 19.6-.44 4.38-3.17 8.58-6.2 11.65-1.05 1.06-2.04 1.6-3.37.48l-3.04-5.57c-.62.19-1.28.05-1.84-.24-.13 2.09-1.28 4.07-3.26 4.87-1.43.57-4.07.82-5.59.66-.58-.06-1.07-.5-1.15-1.09-.16-1.19 0-3.39.3-4.57.64-2.54 2.5-4.17 5.13-4.35-.13-.61-.39-1.19-.16-1.84l-5.1-2.71c-2.32-1.68-.54-3.23.93-4.54 3-2.67 6.64-4.97 10.73-5.36 4.72-5.18 10.99-8.55 17.84-10.02 1.35-.29 3.53-.96 4.63.08Zm-.88.96c-.16-.16-.49-.27-.72-.26-.66.02-1.79.28-2.47.42s-1.37.36-2.06.46l4.52 4.64c.18.04.1-.08.13-.19.31-1.13.83-3.23.86-4.35 0-.23-.1-.56-.26-.72Zm-6.88 1.11c-.38.04-1.29.4-1.7.55-6.36 2.27-12.61 7.39-15.75 13.4-.26.5-.87 1.64-.99 2.14-.03.11-.06.19.04.28l7.85 7.85c.2.08 1.93-.8 2.24-.96 3.13-1.64 5.98-3.95 8.24-6.65 2.65-3.16 4.71-6.98 5.84-10.95-.71-.58-5.37-5.69-5.77-5.65Zm-15.99 9.43c-2.91.52-5.64 2.3-7.88 4.16-.51.42-1.75 1.44-2.09 1.92-.23.32-.26.59-.04.93l5.13 2.76c.93-3.53 2.71-6.85 4.88-9.77Zm4.16 15.37-7.21-7.21c-.15.49-.35.97-.5 1.46-.35 1.1-.86 2.08-.06 3.07.65.81 2.44 2.59 3.24 3.24.16.13.33.28.52.36.65.26 1.86-.2 2.54-.42.49-.16.97-.35 1.46-.5Zm-1.6 1.85 2.61 4.96c.21.28.48.38.81.26.39-.13 1.79-1.76 2.15-2.18 1.89-2.26 3.68-5 4.2-7.93-2.91 2.2-6.24 3.95-9.77 4.88Zm-6.82-3.19c-.35.01-1.37.24-1.75.34-2.67.73-3.2 3.04-3.29 5.52 0 .25-.04 1.61.08 1.69 2.12.07 4.96.12 6.41-1.69.79-.98.89-2.23 1.11-3.43l-2.35-2.38c-.07-.08-.13-.06-.22-.06Z"
            style={{
                fill: "#354060",
            }}
        />
        <path
            d="M36.26 19.49c5.86-.12 6.05 8.62.62 9.11-6.35.56-6.84-8.98-.62-9.11Zm-.56 1.36c-.62.09-1.45.63-1.86 1.11-2.29 2.76.96 6.64 4.06 4.94 3.19-1.75 1.49-6.58-2.21-6.05Z"
            style={{
                fill: "#354060",
            }}
        />
    </svg>
)
export default IconFechaInicio
